import React, { useEffect, useState } from "react";
// import img from "../../assets/rocket.png";
import { FaArrowRight, FaCheckCircle, FaChevronDown, FaChevronUp, FaCircle } from "react-icons/fa";
import "./webdevelopment.css";
import { FaCircleCheck, FaCircleDollarToSlot, FaCircleDot, FaCircleHalfStroke, FaCircleQuestion, FaRegCircleDot } from "react-icons/fa6";
import img from "../../assets/services images/digital-marketing-rotated.jpg";
import img1 from "../../assets/services images/web-features.png";
import img2 from "../../assets/services images/solutions-1-768x768.png"
import AOS from 'aos';
import 'aos/dist/aos.css';

function Digitalmareting() {
    const [openIndex, setOpenIndex] = useState(0);

    const features = [
        {
            title: "Search Engine Optimization",
            content: "We optimize your website to improve rankings on search engines, helping your audience find you quickly and easily.",
        },
        {
            title: "Social MEdia Marketing",
            content: "We create engaging social media campaigns that increase brand awareness and connect you with your target audience on platforms like Facebook, Instagram, LinkedIn, and more.",
        },
        {
            title: "Content Ceation",
            content: "Our creative team produces high-quality content, from blog posts and articles to videos and infographics, to capture attention and showcase your expertise.",
        },
        {
            title: "Pay-Per-Click(PPC) Advertising",
            content: "We design targeted PPC campaigns that drive immediate traffic, helping you reach potential customers and achieve your advertising goals efficiently.",
        },
     
    ];

    const [activeIndex, setActiveIndex] = useState(null);

    const handleClick = (index) => {
        // If already active, close it — otherwise open
        setActiveIndex(activeIndex === index ? null : index);
    };

    const services = [
        {
            title: "Data-Driven Approach",
            desc: "We use analytics and data insights to inform every decision, ensuring that your campaigns are both effective and cost-efficient.",
        },
        {
            title: "Customized Solutions",
            desc: "Our strategies are designed around your business objectives, target audience, and market position for maximum relevance and impact.",
        },
        {
            title: "Multichannel Expertise",
            desc: "Our team has extensive experience across a wide range of digital channels, allowing us to create cohesive and engaging campaigns that meet your audience where they are.",
        },
    ];



    const toggleFeature = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

      useEffect(() => {
    AOS.init({
      duration: 1200, // fade duration for all (ms)
      easing: "ease-in-out", // smooth effect
      once: true,
    });
  }, []);

    return (
        <>

            <section className="service-section1">
                <div className="service-section1-container">
                    {/* Left side - text */}
                    <div className="text-headers" data-aos="fade-down">
                        <div className="title-line">
                            <FaCircleDot style={{ color: "#ffffff", marginRight: "8px" }} />
                            <h4>Digital Marketing</h4>
                        </div>
                        <div className="breadcrumb-line">
                            <span>
                                <a href="/">Home</a> » <a href="/digitalmarketing">Digital Marketing</a>
                            </span>
                        </div>
                    </div>



                </div>
            </section>

            <div className="container">

                <section className="main-services-section-all">
                    <div className="main-services-container">

                        {/* Left side - image */}
                        <div className="main-services-image"  data-aos="fade-left">
                            <img src={img} alt="Web Development" />
                        </div>

                        {/* Right side - text */}
                        <div className="main-services-content"data-aos="fade-right">
                            <h1>Digital Marketing Services</h1>

                            <p>
                             Accelerate your brand’s growth with REDITE’s powerful digital marketing services. We combine strategic expertise with creativity to help your business reach and engage the right audience across the digital landscape.
                            </p>

                            <h3>Customized Strategies for Maximum Impact</h3>


                            <p>
                                At REDITE, we know that every business is unique. That’s why our digital marketing approach is tailored to meet your specific goals, whether it’s building brand awareness, generating leads, or boosting conversions. Our team specializes in creating impactful campaigns that not only enhance visibility but also drive measurable results.


                            </p>
                        </div>

                    </div>
                </section>

                <section className="webdev-section">
                    <div className="webdev-container">
                        {/* Left - Accordion Section */}
                        <div className="webdev-left" data-aos="fade-right">
                            <h3>KEY FEATURES OF OUR Digital Marketing SERVICES</h3>

                            {features.map((feature, index) => (
                                <div
                                    key={index}
                                    className={`accordion-item ${openIndex === index ? "active" : ""}`}
                                    onClick={() => toggleFeature(index)}
                                >
                                    <div className="accordion-title">
                                        <span>
                                            {index + 1}. {feature.title}:
                                        </span>
                                        {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
                                    </div>

                                    {/* SVG Shape only for active accordion */}
                                    {openIndex === index && (
                                        <svg
                                            version="1.1"
                                            className="svg-shape"
                                            viewBox="0 0 541 64"
                                            height="64"
                                            preserveAspectRatio="none"
                                        >
                                            <polygon
                                                className="path"
                                                points="85,55 81,55 51,55 42.5,64 34,55 0,55 0,0 34.4,0 42.5,9.5 50.6,0 81,0 85,0 541,0 541,55 "
                                            ></polygon>
                                        </svg>
                                    )}

                                    {openIndex === index && (
                                        <div className="accordion-content">
                                            <p>{feature.content}</p>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>

                        {/* Right - Image */}
                        <div className="webdev-right" data-aos="fade-left">
                            <img src={img1} alt="Web Development Illustration" />
                        </div>
                    </div>
                </section>
                <section className="web-dev-section">
                    <div className="web-dev-container">
                        {/* Left Side Image */}
                        <div className="web-dev-left" data-aos="fade-up">
                            <img src={img2} alt="Web Development" />
                        </div>

                        {/* Right Side Content */}
                        <div className="web-dev-right" data-aos="fade-down">
                            <h4>Why Choose REDITE for Digital Marketing?</h4>

                            {services.map((item, index) => (
                                <div
                                    key={index}
                                    className={`web-dev-box ${activeIndex === index ? "active" : ""}`}
                                    onClick={() => handleClick(index)}
                                >
                                    <div className="web-dev-box-header">
                                        <FaCheckCircle className="icon" />
                                        <h5>{item.title}:</h5>
                                    </div>

                                    {activeIndex === index && (
                                        <p className="web-dev-desc">{item.desc}</p>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="all-services-page">
                    <div className="all-services-container" data-aos="fade-left">
                        <h4>Our Process: Driven by Results</h4>
                        <p>
                           REDITE’s digital marketing process is results-oriented, focusing on driving growth and achieving your business goals. We begin with a comprehensive analysis of your market, competitors, and audience to identify opportunities. Throughout the campaign, we continuously monitor and optimize for performance, making adjustments to ensure maximum impact.
                        </p>

                        <h4>Take Your Brand to New Heights with REDITE</h4>
                       

                        <p>
                            Ready to expand your online presence and reach your ideal audience? 
                            <span> Let REDITE’s digital marketing experts create a tailored strategy that helps your brand stand out.</span>Contact us today to start your journey to digital success!
                        </p>
                    </div>
                </section>

            </div>
        </>
    );
}

export default Digitalmareting;
